import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapSortVariants } from '../../mappers';

import { TReduxActions } from '../../types/redux';
import { ISortVariant } from '../../types/sortVariant';

const defaultState: ISortVariant[] = [];

export function sortVariantsReducer(state: ISortVariant[] = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapSortVariants(action.payload);
  }

  return state;
}
